// eslint-disable-next-line import/prefer-default-export
export const errorOnValidateAmount = amount => {
  if (!amount) {
    return true;
  } if (amount && /^\d{1,4}((\.|,)\d{1,2})?$/.test(amount)) {
    return false;
  }
  return true;
};
